import type { IconHome } from '@tabler/icons-react';

type TablerIcon = typeof IconHome;

/**
 * Icône en pastille colorée, comme dans « Gestion Bulletins » : fond de couleur
 * (la couleur donne le sens du menu), pictogramme blanc à 58 % de la taille.
 */
export function AppIcon({
  icon: Icon,
  color,
  size = 28,
  plain = false,
}: {
  icon: TablerIcon;
  color: string;
  size?: number;
  plain?: boolean;
}) {
  if (plain) return <Icon size={size} stroke={2} color={color} aria-hidden />;
  return (
    <span className="ico" style={{ background: color, width: size, height: size }} aria-hidden>
      <Icon size={Math.round(size * 0.58)} stroke={2} color="#fff" />
    </span>
  );
}
